import { LocalActivity, OnlinePrediction, People, Settings } from "@mui/icons-material";
import { W2d2dNavigation } from "../W2d2dNavigation.tsx";
import AppFwApp from "../../appfw/ui/AppFwApp";
import { Navigation } from "@toolpad/core";
import { createTheme } from "@mui/material";
import { useMemo } from "react";
import { deDE } from '@mui/x-date-pickers/locales';
import { IdeasControlProvider } from "./hooks/useIdeasControl";
import { PodsControlProvider } from "./hooks/use-pods-control.tsx";
import { ConnectionsControlProvider } from "./hooks/useConnectionsControl.tsx";

const theme = createTheme(
    {
        palette: {
            primary: {
                main: "#256377",
            },
        },
        components: {
            MuiCssBaseline: {
                styleOverrides: {
                    html: {
                        userSelect: 'none',
                        WebkitUserSelect: 'none',
                        WebkitTapHighlightColor: 'transparent',
                    },
                    // Re-enable text selection for text content
                    'p, h1, h2, h3, h4, h5, h6, span, input, textarea, a': {
                        userSelect: 'text',
                        WebkitUserSelect: 'text',
                        cursor: 'auto'
                    },
                    // Explicitly enable selection for generic text containers which might not be p or span tags
                    '.MuiTypography-root': {
                        userSelect: 'text',
                        WebkitUserSelect: 'text',
                        cursor: 'text'
                    }
                }
            }
        }
    },
    deDE,
)

export default function W2d2dApp() {

    const defaultBranding = useMemo(() => ({
        title: 'What to do today?',
        homeUrl: W2d2dNavigation.ideas.path,
        logo: (<></>),
    }), [])

    // TODO: use memo?
    const navigation: Navigation = [
        {
            segment: W2d2dNavigation.ideas.path.substring(1),
            title: "Ideen",
            icon: <OnlinePrediction />,
        }, {
            segment: W2d2dNavigation.events.path.substring(1),
            title: "Events",
            icon: <LocalActivity />,
        }, {
            segment: W2d2dNavigation.connections.path.substring(1),
            title: "Freunde",
            icon: <People />,
        }, {
            segment: W2d2dNavigation.settings.path.substring(1),
            title: "Einstellungen",
            icon: <Settings />,
        },
    ]

    return (
        <IdeasControlProvider>
            <PodsControlProvider>
                <ConnectionsControlProvider>
                    <AppFwApp
                        theme={theme}
                        defaultBranding={defaultBranding}
                        navigation={navigation}
                        layout={"mobile"}
                    />
                </ConnectionsControlProvider>
            </PodsControlProvider>
        </IdeasControlProvider>
    )
}
